import { createSlice } from '@reduxjs/toolkit';

interface networkStatus {
  status: boolean;
  reconnecting: boolean;
  socketStatus: boolean;
  syncStatus: boolean;
  checkOfflineType: 'auto' | 'manual'; // Controls whether NATS monitoring is automatic or manual
}

const initialState: networkStatus = {
  status: true,
  syncStatus: false,
  reconnecting: false,
  socketStatus: true,
  checkOfflineType: 'auto',
};

const networkSlice = createSlice({
  name: 'networkSlice',
  initialState,
  reducers: {
    setNetworkStatus: (state, action) => ({
      ...state,
      status: action.payload,
    }),
    setSyncStatus: (state, action) => ({
      ...state,
      syncStatus: action.payload,
    }),
    setReconnecting: (state, action) => ({
      ...state,
      reconnecting: action.payload,
    }),
    setSocketStatus: (state, action) => ({
      ...state,
      socketStatus: action.payload,
    }),
    setCheckOfflineType: (state, action) => ({
      ...state,
      checkOfflineType: action.payload,
    }),
  },
});

export default networkSlice;
